import { selectExternalInfos } from '@/domain/external/external.selectors';
import { useAppSelector } from '@/ui/hook/store';

import { AlertMessageFormIsValidated } from './AlertMessageFormIsValidated';
import { Layout } from './Layout';

export function ReadOnlyForm({ children }: { children: React.ReactNode }) {
  const infos = useAppSelector(selectExternalInfos);
  return (
    <Layout userName={infos.userName}>
      <AlertMessageFormIsValidated />
      {children}
    </Layout>
  );
}
